import { getLabelsTypeNode, getLabelsWarehouseType, warehouseTypes } from '~/fucntion/node/utils'
export const getListLabelTypeNodeAndWarehouse = (types: [string], options?: { [key: string]: any }) => {
  let labels = ''
  let between = ', '
  if (options?.between) {
    between = options?.between
  }

  if (!Array.isArray(types)) {
    return ''
  }

  if (!(types.length > 0)) {
    return ''
  }

  types.forEach((nodeType, index) => {
    const labelsNode = !warehouseTypes.includes(nodeType) ? getLabelsTypeNode(nodeType) : getLabelsWarehouseType(nodeType)
    if (labelsNode) {
      if (!labels) {
        labels = labels + labelsNode
      } else {
        labels = labels + between + labelsNode
      }
    }
  })

  return labels
}

export const getListLabelTask = (tasks: [{ [key: string]: string }], options?: { [key: string]: any }) => {
  let labels = ''
  let between = ', '
  if (options?.between) {
    between = options?.between
  }

  tasks.forEach((task) => {
    if (!labels) {
      labels = labels + task.name
    } else {
      labels = labels + between + task.name
    }
  })
  return labels
}
